import React, { useState, useEffect, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { useSnackbar } from "notistack";

export default function Dashboard(props) {
  const { isAuthenticated, userType } = useContext(AuthContext);
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const { search } = useLocation();
  const tab = new URLSearchParams(search).get("tab");

  useEffect(() => {
    if (!isAuthenticated) {
      history.push("/login");
      return;
    }
    let isMounted = true;
    const controller = new AbortController();

    async function loadTemplate() {
      try {
        let url = `/api/seeker/profile?st=${
          tab === null || tab === undefined ? "" : tab
        }`;
        if (userType == "employer") {
          url = `/api/employer/profile?st=${
            tab === null || tab === undefined ? "" : tab
          }`;
        }

        const resp = await axios.get(url, { signal: controller.signal });

        if (!isMounted) return;
        if (resp.data.status == "success") {
          $("#templateRenderDiv").html(resp.data.template);
        } else {
          enqueueSnackbar(resp.data.message, { variant: "error" });
        }
      } catch (error) {
        if (!isMounted) return;
        if (error.name !== "AbortError" && error.name !== "CanceledError") {
        // if (error.name !== "AbortError") {
          console.error("Failed to load dashboard template:", error);
          enqueueSnackbar("Failed to load dashboard", { variant: "error" });
        }
      }
    }

    loadTemplate();

    // Cleanup: cancel request if component unmounts
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [isAuthenticated, tab, userType]);

  return <div id="templateRenderDiv"></div>;
}
